export const downloadTunnelTemplateAction = 'downloadTunnelTemplateAction';
export const testTunnelConnectionAction = 'testTunnelConnectionAction';
